<ng-template #horizontalLayout>
  <div class="addon-content">
    <div class="text-group text-addon" >
      <span class="room-name">
        {{ offer?.upsell_room_category_name | titlecase }}
      </span>
      <p class="price-text">
        <span class="price-amount">{{ offer?.ofr_price | currency:'USD' : 'symbol' : '1.2-2' }} Extra</span>
      </p>
    </div>

    <div class="button-container btn-container-horizontal">
      @if (sharedService.requestOnlyMode) {
        <button
          class="button-offer-card addon-button card-action-desktop"
          [class.button-disabled]="checkIfDisabled()"
          (click)="requestUpgrade()">
          Request Upgrade
        </button>
      }

      @if (!checkIfOfferInCart() && !sharedService.requestOnlyMode) {
        <button
          class="button-offer-card addon-button card-action-desktop"
          type="button"
          [class.button-disabled]="checkIfDisabled()"
          (click)="addToCartAndContinue($event);">
          <span class="material-icons cart-icon">add_shopping_cart</span>
          <span class="cart-label">Add to Cart</span>
        </button>
      }

      @if (checkIfOfferInCart() && !sharedService.requestOnlyMode) {
        <button
          class="button-offer-card addon-button card-action-desktop"
          [class.button-disabled]="checkIfDisabled()"
          (click)="removeOfferFromCart();">
          <span class="material-icons cart-icon">remove_shopping_cart</span>
          <span class="cart-label">Remove</span>
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #verticalLayout>
  <div class="vertical-container">
    <div class="offer-card-row card-row-handset">
      <div class="offer-room-label text-addon">
        <span class="offer-room-text">{{ offer?.upsell_room_category_name | titlecase }}</span>
        <span class="offer-price-label"> <span class="price-amount">{{ offer?.ofr_price | currency:'USD':'symbol':'1.2-2' }} Extra</span></span>
      </div>

      <div class="btn-container-vertical">
        @if (sharedService.requestOnlyMode) {
          <button
            class="button-offer-card addon-button addon-button-handset card-action-handset"
            [class.button-disabled]="checkIfDisabled()"
            (click)="requestUpgrade()">
            Request Upgrade
          </button>
        }

        @if (!sharedService.requestOnlyMode && !checkIfOfferInCart()) {
          <button
            class="button-offer-card addon-button addon-button-handset card-action-handset"
            type="button"
            [class.button-disabled]="checkIfDisabled()"
            (click)="addToCartAndContinue($event);">
            <span class="material-icons cart-icon">add_shopping_cart</span>
            <span class="cart-label">Add to Cart</span>
          </button>
        }

        @if (!sharedService.requestOnlyMode && checkIfOfferInCart()) {
          <button
            class="button-offer-card addon-button addon-button-handset card-action-handset"
            [class.button-disabled]="checkIfDisabled()"
            (click)="removeOfferFromCart()">
            <span class="material-icons cart-icon">remove_shopping_cart</span>
            <span class="cart-label">Remove</span>
          </button>
        }
      </div>

    </div>
  </div>
</ng-template>

<div class="lx-card">
  <div class="addon-container" [class.force-vertical]="shouldUseVerticalLayout()">
    @if (shouldUseVerticalLayout()) {
      <ng-container [ngTemplateOutlet]="verticalLayout"></ng-container>
    } @else {
      <ng-container [ngTemplateOutlet]="horizontalLayout"></ng-container>
    }
  </div>
</div>
